<template>
  <div>
    <hot-table
      ref="hotTableComponent"
      :settings="settings"
      licenseKey="non-commercial-and-evaluation"
      width="100%"
    ></hot-table>
    <br>
    <b-btn class="px-5" @click="addRow()" v-if="collectionCode && (collectionCodeStatus == 'open' || collectionCodeStatus == 'editing' || collectionCodeStatus == 'draft')">Add Row</b-btn>
    <!-- <b-container flex v-if="template.id != 'deleted' && collectionCode">
      <b-row>
        <b-col>
          
        </b-col>
      </b-row>
    </b-container> -->
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";

import { HotTable } from "@handsontable/vue";
import Handsontable from 'handsontable';

import { mapState, mapGetters, mapActions } from "vuex";

import * as _ from "lodash";

export default {
  components: {
    HotTable
  },
  props: {
    collectionCode: {
      type: String,
      default: ''
    },
    collectionCodeStatus: {
      type: String,
      default: 'open'
    },
    templateId: {
      type: String,
      required: true
    },
    startDate: {
        type: String,
        default: ''
    },
    endDate: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
      save_message: null,
      error_message: null,
      data: [],
      settings: {
        data: [],
        stretchH: "all",
        rowHeaders: true,
        colHeaders: [],
        columns: [],
        comments: true,
        licenseKey: "non-commercial-and-evaluation"
      },
      template: {},
      columns: {},
      periods: ["F01", "F02", "F03"],
      period: null,
      templateIDs: [
        "ento_its2",
        "microscopy",
        "pcr",
        "kdr",
        "males",
        "other",
        "deleted",
        "culex",
        "individual_mosquito_entry",
        "mali_individual_mosquito_entry"
      ],
      colIds: [],
      collectionCodes: []
    };
  },
  computed: {
    ...mapState("websheet", ["templates"]),
    ...mapGetters("websheet", ["getTemplateById"]),
    ...mapGetters('user', ['inMyGroups'])
  },
  watch: {
    collectionCode: function() {
      this.search();
    },
    collectionCodeStatus: function() {
      if(this.template && this.template.id) {
        this.initWebsheet(this.template.id);
        this.search();
      } else {
        this.search();
      }
    },
    endDate: function(newVal, oldVal) {
        if(this.endDate) {
            this.search();
        }
    }
  },
  mounted() {
    const that = this;

    if (this.templates.length) {
      this.initWebsheet(that.templateId);
    } else {
      this.getTemplates().then(response => {
        this.setTemplates(response.data);
        this.initWebsheet(that.templateId);
      });
    }
  },
  methods: {
    ...mapActions(["setAlert"]),
    ...mapActions("websheet", ["getTemplates", "setTemplates", "getEntoData", "getEntoCollectionCodes"]),
    search: function() {
      let that = this;
      that.settings.data = [];

      // Set the request data.
      let data = {
          collection_code: that.collectionCode,
          start_date: that.startDate,
          end_date: that.endDate
      };

      that.getEntoData(data).then(response => {
        let data = [];

        if(that.endDate && (that.template.id === 'pcr' || that.template.id === 'kdr')) {
            _.each(response.data, function(item) {
                if (item.status !== 'archived' && item.anoph_species_morpho !== "Culex") {
                    data.push(item);
                }
            });
        } else if (that.template.id === "deleted") {
          _.each(response.data, function(item) {
            if (item.deleted) {
              item.deleted = "Yes";
              data.push(item);
            }
          });
        } else if (that.template.id === "mali_deleted") {
          _.each(response.data, function(item) {
            if (item.deleted) {
              item.deleted = "Yes";
              data.push(item);
            }
          });
        } else if (that.template.id === "other") {
          _.each(response.data, function(item) {
            if (
              !item.deleted &&
              item.anoph_sex !== "Male" &&
              item.pcr_anoph_species_molecular === "Other" &&
              anoph_species_morpho !== "Culex"
            ) {
              item.deleted = "Yes";
              data.push(item);
            }
          });
        } else if (that.template.id === "males") {
          _.each(response.data, function(item) {
            if (
              !item.deleted &&
              item.anoph_sex === "Male" &&
              item.anoph_species_morpho !== "Culex"
            ) {
              item.deleted = "No";
              data.push(item);
            }
          });
        } else if (that.template.id === "culex") {
          _.each(response.data, function(item) {
            if (
              !item.deleted &&
              item.anoph_species_morpho === "Culex"
            ) {
              item.deleted = "No";
              data.push(item);
            }
          });
        } else if (that.template.id === "individual_mosquito_entry") {
          _.each(response.data, function(item) {
            if (
              !item.deleted
            ) {
              console.log(item)
              item.deleted = "No";
              data.push(item);
            }
          });
        } else if (that.template.id === "mali_individual_mosquito_entry") {
          _.each(response.data, function(item) {
            console.log("ITEM")
            if (
              !item.deleted
            ) {
              console.log(item)
              item.deleted = "No";
              data.push(item);
            }
          });
        } else {  // that.template.id === 'ento_its2'
          _.each(response.data, function(item) {
            if (
              !item.deleted &&
              item.anoph_sex !== "Male" &&
              item.pcr_anoph_species_molecular !== "Other" &&
              item.anoph_species_morpho !== "Culex"
            ) {
              item.deleted = "No";
              data.push(item);
            }
          });
        }

        // If collection is locked, eliminate those from consideration.
        let final_data = [];
        if(that.collectionCodeStatus === 'locked') {
          _.each(data, function(item) {
            if(item.status !== 'archived') {
              final_data.push(item);
            }
          });
        } else {
          final_data = data;
        }

        that.settings.data = final_data;
      });
    },
    addRow: function() {
      const that = this;
      let data = {collection_code: that.collectionCode};

      if (that.template.id == "other") {
        data.other = "other"
      } else {
        data.other = "not"
      }

      HTTP.post("/kenya/ento-data-add-row/", data).then((response) => {
        response.data.deleted = "No"
        that.settings.data.push(response.data);
      }).catch((error) => {
        this.$notify({
          text: error.response.data.message,
          duration: 10000,
          type: "error",
        });
      });
    },
    switchTemplate: function(templateId) {
      this.initWebsheet(templateId);
    },
    initWebsheet(templateId) {
      let that = this;

      this.template = this.getTemplateById(templateId);

      if(!that.template || !that.$refs.hotTableComponent) {
          return;
      }

      that.settings.data = []; // Clear the current data.
      that.settings.colHeaders = [];
      that.colIds = [];
      that.settings.colHeaders = _.map(that.template.columns, item => {
        let display = item.name ? item.name : item.id;
        that.colIds.push(item.id);
        return display;
      });

      // Renderer that sets the background of archived rows to #ccc to make the edit rows pop.
      let archivedRenderer = function(instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        td.style.backgroundColor = '#ccc';
      };

      that.settings.cells = function(row, col, prop) {
        var cellProperties = {};

        if(that.settings.data.length) {
          let row_data = that.settings.data[row];

          if(row_data['status'] === 'locked' || row_data['status'] === 'archived') {
            cellProperties.readOnly = true;
          }

          // If the status is review required, then ONLY make the status available.
          if(that.collectionCodeStatus === 'review_required') {
            if(prop !== 'status') {
              cellProperties.readOnly = true;
            }
          } else if(that.collectionCodeStatus === 'open' || that.collectionCodeStatus === 'editing' || that.collectionCodeStatus === 'changes_rejected') {
            if(prop === 'status') {
              cellProperties.readOnly = true;
            }
          } else if(that.endDate && row_data['status'] != 'archived') {
              // If we are doing the date range filter, show the rows.
              cellProperties.readOnly = false;
          }

          // Readonly if range filter and mostquito code.
          if(that.endDate && prop === 'mosquito_code') {
              cellProperties.readOnly = true;
          }

          // Always disable thread column.
          if(prop === 'thread') {
            cellProperties.readOnly = true;
          }

          // Check if this person is in an allowed group.
          if(!that.inMyGroups(['Ento Data Entry Clerk', 'Data Manager'])) {
            cellProperties.readOnly = true;
          }

          // Render archived cells
          if(row_data['status'] === 'archived') {
            this.renderer = archivedRenderer;
          }

          // Date format for result_date.
          if(prop === 'result_date') {
              this.dateFormat = 'YYYY-MM-DD';
          }

          // Read only for columns when deleted.
          if(that.template.id === "deleted" && prop !== "deleted") {
              cellProperties.readOnly = true;
          }
        }

        return cellProperties;
      }

      that.settings.columns = [];

      // Itereate each column and set the data.
      _.each(that.template.columns, function(item) {
        // var col_id = item.name ? item.name : item.id;
        var col = {
          data: item.id,
          type: item.type
        };

        // Dropdown.
        if (item.values.length) {
          col.type = "dropdown";
          col.source = item.values;

          // If status column, just have the locked/rejected values.
          if(that.collectionCodeStatus === 'review_required' && item.name === 'Status') {
            col.source = ['locked', 'rejected'];
          }
        }

        // If this column is deleted column, change the values.
        if(col.data === "deleted") {
          col.type = 'checkbox';
          col.checkedTemplate = 'Yes';
          col.uncheckedTemplate = 'No';
        }

        // Readonly
        if (
          (that.template.id == "ento_its2" || that.template.id == "other" || that.template.id == "males") &&
          item.id == "mosquito_code"
        ) {
          col.readOnly = false;
        } else {
          col.readOnly = item.readonly;
        }

        // status
        if(that.collectionCodeStatus == 'locked') {
          col.readOnly = true;
        }

        // If template id is deleted, make all columns except "Delete" 
        if(that.template.id === "deleted" && item.id !== "deleted") {
            col.readonly = true;
        }

        that.settings.columns.push(col);
      });

      that.$refs.hotTableComponent.hotInstance.updateSettings({
        afterChange: function(changes, source) {
          if (source == "loadData") {
            return;
          }

          changes.forEach(([row, prop, oldValue, newValue]) => {
            let col = that.colIds.indexOf(prop);

            const commentsPlugin = that.$refs.hotTableComponent.hotInstance.getPlugin(
              "comments"
            );
            commentsPlugin.removeCommentAtCell(row, col);
            const post_data = {};
            const row_data = that.settings.data[row];
            post_data[prop] = oldValue;// Used here to remove error, hehe.
            post_data[prop] = newValue;

            that.$refs.hotTableComponent.hotInstance.setCellMeta(
                row,
                col,
                "valid",
                true
            );

            HTTP.put("/kenya/update-ento-data/" + row_data.id, post_data)
              .then(() => {
                if(prop === "deleted") {
                  var plugin = that.$refs.hotTableComponent.hotInstance.getPlugin('hiddenRows');
                  plugin.enablePlugin();
                  plugin.hideRow(row);
                  that.$refs.hotTableComponent.hotInstance.render();
                }

                // if(prop === "od_reading") {
                //     that.$refs.hotTableComponent.hotInstance.setCellMeta(
                //         row,
                //         col,
                //         "valid",
                //         false
                //     );
                // }

                that.$refs.hotTableComponent.hotInstance.render();
              })
              .catch(error => {
                that.$refs.hotTableComponent.hotInstance.setCellMeta(
                  row,
                  col,
                  "valid",
                  false
                );
                commentsPlugin.setCommentAtCell(
                  row,
                  col,
                  error.response.data[prop]
                );
                commentsPlugin.showAtCell(row, col);
                that.$refs.hotTableComponent.hotInstance.render();
              });
          });

          that.$refs.hotTableComponent.hotInstance.render();
        }
      });

      that.search();
    }
  }
};
</script>

<style>
</style>